
import React, { useEffect, useState } from 'react';
import { PopupContent } from '@/types/popup-system';
import { MOTIVATIONAL_POPUP_STYLES } from '../motivational-popups/PopupContentDefinitions';
import { useMotivationalEffects } from './motivational/useMotivationalEffects';
import { MotivationalBackdrop } from './motivational/MotivationalBackdrop';
import { MotivationalTitleBar } from './motivational/MotivationalTitleBar';
import { MotivationalContent } from './motivational/MotivationalContent';
import { MOTIVATIONAL_POPUP_CSS } from './motivational/MotivationalPopupStyles';

interface MotivationalPopupProps {
  content: PopupContent;
  onDismiss: () => void;
  onAction?: (action: string) => void;
}

export const MotivationalPopup = ({ content, onDismiss, onAction }: MotivationalPopupProps) => {
  const [currentStyle, setCurrentStyle] = useState(MOTIVATIONAL_POPUP_STYLES[0]);

  // Get the appropriate style (cycle through them)
  useEffect(() => {
    const styleIndex = parseInt(localStorage.getItem('motivational-popup-style-index') || '0');
    const style = MOTIVATIONAL_POPUP_STYLES[styleIndex] || MOTIVATIONAL_POPUP_STYLES[0];
    setCurrentStyle(style);
  }, []);

  const { getEffectClass } = useMotivationalEffects(currentStyle.specialEffects);

  const handleAction = (action: string) => {
    if (onAction) {
      onAction(action);
    }
    onDismiss();
  };

  // Create dynamic CSS variables for the current style
  const styleVars = {
    '--popup-bg': currentStyle.backgroundColor,
    '--popup-text': currentStyle.textColor,
    '--popup-border': currentStyle.borderColor,
    '--popup-title-bg': currentStyle.titleBarColor,
    '--popup-button-bg': currentStyle.buttonColor,
    '--popup-shadow': currentStyle.shadowColor || 'rgba(0,0,0,0.3)',
    '--popup-font': currentStyle.fontFamily
  } as React.CSSProperties;

  return (
    <>
      <MotivationalBackdrop onDismiss={onDismiss} />
      
      {/* Popup */}
      <div 
        className={`
          fixed left-1/2 top-1/2 z-[9999] w-96 max-w-[90vw] -translate-x-1/2 -translate-y-1/2 
          motivational-popup ${getEffectClass()}
          border-2 shadow-2xl
        `}
        style={{
          ...styleVars,
          backgroundColor: 'var(--popup-bg)',
          borderColor: 'var(--popup-border)',
          fontFamily: 'var(--popup-font)',
          boxShadow: `0 0 20px var(--popup-shadow), inset 0 1px 0 rgba(255,255,255,0.1)`
        }}
      >
        <MotivationalTitleBar title={content.title} onDismiss={onDismiss} />
        <MotivationalContent content={content} onAction={handleAction} />
      </div>

      {/* CSS Styles */}
      <style dangerouslySetInnerHTML={{ __html: MOTIVATIONAL_POPUP_CSS }} />
    </>
  );
};
